















































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Icon, Input, List, Modal, Select, Tabs} from "ant-design-vue";
import PersonalHeader from "@/components/Personal/PersonalHeader.vue";
import ReservationItem from "@/components/Personal/MyReservation/ReservationItem.vue";
import {getCancelServiceList, reservationOrderDropList, reservationOrderList} from "@/services/api";
import aSpin from "@/components/aSpin.vue";

Vue.use(Tabs);
Vue.use(Input);
Vue.use(List);
Vue.use(Icon);
Vue.use(Modal);
Vue.use(Select);

@Component({
    components: {
        PersonalHeader,
        ReservationItem,
        aSpin
    }
})
export default class extends Vue {
    @Prop() public emptyTextBySearch: any;
    allReservationStatus: any = {
        0: "预约单状态",
        239: "已预约",
        240: "进行中",
        241: "已完成",
        243: "已取消",
    };
    agencyAppointmentForm = false

    //input框查询数据
    getSearchItem(val) {
        this.pagination.pageIndex = 1;
        this.reservationOrderList(this.statusKey, val);
    }
    loading = true;
    statusKey = 0;

    @Prop({
        type: Number,
        required: true,
        default: null
    })
    public status!: null;

    @Watch("status", {immediate: true, deep: true})
    getStatus(newVal, oldVal) {
        this.statusKey = newVal;
        if (newVal === 0) {
            this.reservationOrder(newVal, "")
        } else {
            this.reservationOrderList(newVal, "");
        }

    }

    cancelReason = [];

    created() {
        getCancelServiceList({typeId: "150"}).then((res: any) => {
            this.cancelReason = res["data"];
        });
    }

    data = [];
    pagination = {
        total: 0,
        pageSize: 5,
        pageIndex: 1
    };

    //获取未选中的数据(tab切换显示用的数据)
    reservationOrder(status: Number, searchInput: String) {
        if (searchInput) {
            this.$emit("emptyTextBySearch", true);
        } else {
            this.$emit("emptyTextBySearch", false);
        }
        status = status || this.statusKey;
        reservationOrderList({
            ...this.pagination,
            status: status === 0 ? "" : status,
            searchInput: searchInput
        }).then(res => {
            let data = res.data;
            this.pagination.total = data.totalCount;
            this.data = data.serviceOrderInfos;
            this.loading=false
            this.pagination.pageSize = data.pageSize;
        });
    }

    reservationOrderList(status: Number, searchInput: String) {
        if (searchInput) {
            this.$emit("emptyTextBySearch", true);
        } else {
            this.$emit("emptyTextBySearch", false);
        }
        status = status || this.statusKey;
        reservationOrderList({
            ...this.pagination,
            status: status === 0 ? "" : status,
            searchInput: searchInput
        }).then(res => {
            let data = res.data;
            if (data.serviceOrderInfos.length===0) {
                this.$emit("emptyTextBySearch", true);
            }
            this.pagination.total = data.totalCount;
            this.data = data.serviceOrderInfos;
            this.loading=false
            this.pagination.pageSize = data.pageSize;
        });
    }

    againGetList() {
        this.pagination.pageIndex = 1;
        this.reservationOrderList(this.statusKey, "");
    }

    stateKeyShow = "预约单状态";

    reversationStatusChange(key, name) {
        this.agencyAppointmentForm = false
        this.emptyTextBySearch = false;
        this.stateKeyShow = name;
        this.pagination.pageIndex = 1;
        if (key === "0") {
            this.reservationOrderDropList(null);
        } else {
            this.reservationOrderDropList(key);
        }

    }

    reservationOrderDropList(key) {
        reservationOrderDropList({
            ...this.pagination,
            rStatus: key
        }).then(res => {
            let data = res.data;
            this.pagination.total = data.totalCount;
            this.data = data.serviceOrderInfos;
            this.pagination.pageSize = data.pageSize;
        });
    }

    onChangePageSize(page, pageSize) {
        window.scrollTo(0, 0);
        this.pagination.pageIndex = page;
        this.reservationOrderList(this.statusKey, "");
    }
}
